import { useContext, useEffect, useState } from "react";
import { CatalogoContext } from "../../../contexts/Catalogo/CatalogoContext";
import { ConfiguracoesContext } from "../../../contexts/Configuracoes/ConfiguracoesContext";
import { PagSeguroContext } from "../../../contexts/PagSeguro/PagSeguroContext";
import { useTheme } from "../../../contexts/Theme/ThemeContext";
import { deepCopy } from "../../../services/Functions";
import { currencyMask, percentageMask } from "../../../services/Masks";
import { unmaskPercentage, unmaskToNumbers } from "../../../services/Unmasks";
import Configuracoes from "../../../types/Configuracoes";
import Dropdown from "../../Dropdowns/Dropdown";
import { Input } from "../../Input";
import Titulo from "../../Modal/ModaisConfigsPrimeiroAcesso/Titulo/Titulo";
import { Select } from "../../Select";
import { Toggle } from "../../Toggle/Toggle";
import { ToggleConfigurar } from "../../Toggle/ToggleConfigurar/ToggleConfigurar";
import { ContainerIntermediadorContainer } from "./styles";

interface IntermediadoresProps {
  configIn: "catalogo" | "empresa" | "configuracoes";
  intermediador: "pagseguro" | "pagarme" | "mercadopago" | "pagarmehub";
  somenteAtivar?: boolean; // Dropshipping: só liga/desliga cartão e pix, sem editar as configurações
}

const Intermediadores: React.FC<IntermediadoresProps> = ({
  configIn,
  intermediador,
  somenteAtivar,
}) => {

  const configsEmpresaContext = useContext(ConfiguracoesContext);
  const configsCatalogoContext = useContext(CatalogoContext);
  
  const pagSeguroApi = useContext(PagSeguroContext);

  const { theme } = useTheme();

  const configuracoes: any =
    configIn === "catalogo"
      ? configsCatalogoContext.catalogo
      : configsEmpresaContext.configuracoes
  const setConfiguracoes =
    configIn === "catalogo"
      ? configsCatalogoContext.setCatalogo
      : configsEmpresaContext.setConfiguracoes

  const ignoreValidation =
    configIn === "catalogo"
      ? false
      : (
        !(configuracoes as Configuracoes).pagamentoOnlineAtivo
      );


  const [configsCartao, setConfigsCartao] = useState(true);
  const [configsPix, setConfigsPix] = useState(true);

  const parcelas = [
    { value: 1, name: "1 parcela" },
    { value: 2, name: "2 parcelas" },
    { value: 3, name: "3 parcelas" },
    { value: 4, name: "4 parcelas" },
    { value: 5, name: "5 parcelas" },
    { value: 6, name: "6 parcelas" },
    { value: 7, name: "7 parcelas" },
    { value: 8, name: "8 parcelas" },
    { value: 9, name: "9 parcelas" },
    { value: 10, name: "10 parcelas" },
    { value: 11, name: "11 parcelas" },
    { value: 12, name: "12 parcelas" },
  ];

  useEffect(() => {
    const dados = configuracoes?.intermediadores?.[intermediador];
    if(configuracoes && configuracoes.intermediadores && (!dados || !dados.cartao || !dados.pix)){
      let newConfigs = {
        ...configuracoes,
        intermediadores: {
          ...configuracoes.intermediadores,
          [intermediador]: {
            cartao: {
              ativo: true,
              quantidade_maxima_parcelas: 1,
              valor_minimo_parcela: "0",
              ...dados?.cartao,
            },
            pix: {
              ativo: true,
              percentual_desconto: "0",
              dias_cancelamento: "",
              dias_cancelamento_data_ativacao: "",
              ...dados?.pix,
            },
          },
        },
      }
      configIn === "catalogo" ? setConfiguracoes(newConfigs) : setConfiguracoes(newConfigs)
    }
  }, [configuracoes])

  return (
    <>
      {configuracoes.intermediadores[intermediador] && (
        <ContainerIntermediadorContainer configIn={configIn} theme={theme}>
          <div className={`containerIntermediadores`}>
            {configIn === "empresa" && (
              <Titulo
                titulo={
                  intermediador.charAt(0).toUpperCase() + intermediador.slice(1)
                }
                subtitulo={
                  "Formas de pagamento solicitadas <br/> ao finalizar a compra."
                }
                flexDirection="column-reverse"
              ></Titulo>
            )}
            <div className="togglesContainer">
              <ToggleConfigurar
                ignoreValidations={ignoreValidation}
                nome={"Cartão de crédito"}
                value={
                  configuracoes.intermediadores[intermediador]?.cartao.ativo!
                }
                isValid={() => {
                  return (
                    configuracoes.intermediadores[intermediador]?.cartao.ativo! &&
                    !configsCartao &&
                    (!configuracoes.intermediadores[intermediador]?.cartao
                      .quantidade_maxima_parcelas! ||
                      !configuracoes.intermediadores[intermediador]?.cartao
                        .valor_minimo_parcela!)
                      ? false
                      : true
                  )
                }}
                invalidText="Preencha as configurações do cartão de crédito"
                onChange={(newValue) => {
                  if (
                    newValue &&
                    !configuracoes.intermediadores[intermediador]?.cartao
                      .quantidade_maxima_parcelas &&
                    !configuracoes.intermediadores[intermediador]?.cartao
                      .valor_minimo_parcela
                  ) {
                    setConfigsCartao(true);
                  }
                  if (!newValue) {
                    setConfigsCartao(false);
                  }
                  setConfiguracoes(
                    deepCopy(configuracoes, {
                      intermediadores: {
                        [intermediador]: { cartao: { ativo: newValue } },
                      },
                    }),
                  );
                }}
                onConfigurar={() => {
                  setConfigsCartao(!configsCartao);
                }}
              />
              <Dropdown active={configsCartao} className="dropdown">
              <fieldset disabled={somenteAtivar} style={{ border: 0, padding: 0, margin: 0, minWidth: 0, ...(somenteAtivar ? { opacity: 0.6, pointerEvents: "none" } : {}) }}>
                <div className="configsCartaoContainer">
                  <Select
                    sizeLabel="medium"
                    options={parcelas}
                    value={
                      configuracoes.intermediadores[intermediador]?.cartao
                        .quantidade_maxima_parcelas
                    }
                    placeholder="6 parcelas"
                    onChange={(newValue) => {
                      setConfiguracoes(
                        deepCopy(configuracoes, {
                          intermediadores: {
                            [intermediador]: {
                              cartao: { quantidade_maxima_parcelas: newValue },
                            },
                          },
                        }),
                      );
                    }}
                    label="Quantidade máxima de parcelas"
                    required={!ignoreValidation && configuracoes.intermediadores[intermediador]?.cartao.ativo}
                  />
                  <Input
                    type="text"
                    ignoreValidations={ignoreValidation || !configuracoes.intermediadores[intermediador]?.cartao.ativo}
                    required={true}
                    value={
                      Number.parseFloat(
                        configuracoes.intermediadores[intermediador]?.cartao
                          .valor_minimo_parcela!,
                      ) > 0
                        ? Number.parseFloat(
                            configuracoes.intermediadores[intermediador]!.cartao
                              .valor_minimo_parcela!,
                          ).toFixed(0)
                        : ""
                    }
                    placeholder="R$ 10,00"
                    mask={{
                      mask: currencyMask,
                      unmask: unmaskToNumbers,
                    }}
                    onChange={(newValue) => {
                      setConfiguracoes(
                        deepCopy(configuracoes, {
                          intermediadores: {
                            [intermediador]: {
                              cartao: { valor_minimo_parcela: newValue },
                            },
                          },
                        }),
                      );
                    }}
                    label="Valor mínimo de cada parcela"
                  />
                </div>
                {Number(configuracoes.intermediadores[intermediador]?.cartao?.quantidade_maxima_parcelas) > 0 && (
                  <div className="jurosParcelasSection">
                    <span className="jurosLabel fonteTexto">Juros por parcela</span>
                    <div className="jurosParcelasGrid">
                      {Array.from(
                        { length: Number(configuracoes.intermediadores[intermediador]?.cartao?.quantidade_maxima_parcelas) },
                        (_, i) => i + 1
                      ).map((n) => (
                        <div key={n} className="jurosInputWrapper">
                          <span className="jurosPrefix fonteTexto">{n}x</span>
                          <Input
                            type="text"
                            ignoreValidations={true}
                            required={false}
                            value={configuracoes.intermediadores[intermediador]?.cartao?.juros_parcelas?.[n.toString()] ?? "0"}
                            placeholder="0%"
                            mask={{
                              mask: percentageMask,
                              unmask: unmaskPercentage,
                            }}
                            onChange={(newValue) => {
                              setConfiguracoes(
                                deepCopy(configuracoes, {
                                  intermediadores: {
                                    [intermediador]: {
                                      cartao: {
                                        juros_parcelas: {
                                          ...configuracoes.intermediadores[intermediador]?.cartao?.juros_parcelas,
                                          [n.toString()]: newValue === "" ? "0" : (Number(newValue) / 100).toFixed(2),
                                        },
                                      },
                                    },
                                  },
                                }),
                              );
                            }}
                            className="jurosInput"
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </fieldset>
              </Dropdown>

              <ToggleConfigurar
                ignoreValidations={ignoreValidation}
                nome={"Pix"}
                value={configuracoes.intermediadores[intermediador]!.pix.ativo}
                isValid={
                  configuracoes.intermediadores[intermediador]?.pix.ativo! &&
                  !configsPix &&
                  !configuracoes.intermediadores[intermediador]?.pix
                    .percentual_desconto!
                    ? false
                    : true
                }
                invalidText="Preencha as configurações do pix"
                onChange={(newValue) => {
                  if (
                    newValue &&
                    !configuracoes.intermediadores[intermediador]?.pix
                      .percentual_desconto
                  ) {
                    setConfigsPix(true);
                  }
                  if (!newValue) {
                    setConfigsPix(false);
                  }
                  setConfiguracoes(
                    deepCopy(configuracoes, {
                      intermediadores: {
                        [intermediador]: { pix: { ativo: newValue } },
                      },
                    }),
                  );
                }}
                onConfigurar={() => {
                  setConfigsPix(!configsPix);
                }}
              />

              <Dropdown active={configsPix} className="dropdown">
              <fieldset disabled={somenteAtivar} style={{ border: 0, padding: 0, margin: 0, minWidth: 0, ...(somenteAtivar ? { opacity: 0.6, pointerEvents: "none" } : {}) }}>
                <div className="configsPixContainer">
                  <Input
                    ignoreValidations={ignoreValidation || !configuracoes.intermediadores[intermediador]?.pix.ativo}
                    type="text"
                    required={true}
                    value={
                      Number.parseFloat(
                        configuracoes.intermediadores[intermediador]!.pix
                          .percentual_desconto,
                      ) > 0
                        ? Number.parseFloat(
                            configuracoes.intermediadores[intermediador]!.pix
                              .percentual_desconto,
                          ).toFixed(0)
                        : "0"
                    }
                    placeholder="10%"
                    mask={{
                      mask: percentageMask,
                      unmask: unmaskPercentage,
                    }}
                    onChange={(newValue) => {
                      setConfiguracoes(
                        deepCopy(configuracoes, {
                          intermediadores: {
                            [intermediador]: {
                              pix: { percentual_desconto: newValue },
                            },
                          },
                        }),
                      );
                    }}
                    label="Porcentagem de desconto"
                  />
                  <div className="cancelamentoContainer">
                    <div className="cancelamentoToggle">
                      <Toggle
                        value={!!configuracoes.intermediadores[intermediador]?.pix?.dias_cancelamento}
                        onChange={(ativo) => {
                          if (ativo) {
                            setConfiguracoes(
                              deepCopy(configuracoes, {
                                intermediadores: {
                                  [intermediador]: {
                                    pix: {
                                      dias_cancelamento: "1",
                                      dias_cancelamento_data_ativacao: new Date().toISOString().split('T')[0],
                                    },
                                  },
                                },
                              }),
                            );
                          } else {
                            setConfiguracoes(
                              deepCopy(configuracoes, {
                                intermediadores: {
                                  [intermediador]: {
                                    pix: {
                                      dias_cancelamento: "",
                                      dias_cancelamento_data_ativacao: "",
                                    },
                                  },
                                },
                              }),
                            );
                          }
                        }}
                      />
                      <span className="fonteTexto">Cancelar pedido automaticamente</span>
                    </div>
                    {!!configuracoes.intermediadores[intermediador]?.pix?.dias_cancelamento_data_ativacao && (
                      <>
                        <Input
                          ignoreValidations={true}
                          type="number"
                          required={false}
                          value={
                            configuracoes.intermediadores[intermediador]?.pix
                              ?.dias_cancelamento || ""
                          }
                          placeholder="Ex: 3"
                          min={1}
                          max={30}
                          onChange={(newValue) => {
                            let valor = newValue;
                            if (Number(newValue) > 30) valor = "30";
                            if (Number(newValue) < 1) valor = "1";
                            setConfiguracoes(
                              deepCopy(configuracoes, {
                                intermediadores: {
                                  [intermediador]: {
                                    pix: { dias_cancelamento: valor },
                                  },
                                },
                              }),
                            );
                          }}
                          label="Prazo limite para pagamento (dias)"
                        />
                        <span className="cancelamentoInfo">
                          Ativo desde {new Date(configuracoes.intermediadores[intermediador]?.pix?.dias_cancelamento_data_ativacao + 'T00:00:00').toLocaleDateString('pt-BR')}. Apenas pedidos realizados a partir desta data serão cancelados automaticamente.
                        </span>
                      </>
                    )}
                  </div>
                </div>
              </fieldset>
              </Dropdown>
            </div>
          </div>
        </ContainerIntermediadorContainer>
      )}
    </>
  );
};
export default Intermediadores;
